import { Controller } from '@hotwired/stimulus';
import showToast from 'lib/toast_notification';

export default class extends Controller {
  static values = {
    maxBytes: Number,
    errorMessage: { type: String, default: 'The selected file is too large.' },
  };

  validate(event) {
    if (!this.hasMaxBytesValue) return;
    const input = event.target;
    const tooBig = Array.from(input.files).some((f) => f.size > this.maxBytesValue);
    if (!tooBig) return;

    input.value = '';
    showToast(this.errorMessageValue, { type: 'error' });
  }
}
